import React from 'react'
import { useTranslation } from 'react-i18next'

function TotalHits({ showingNumberOfHits, totalNumberOfHits }) {
  const { t } = useTranslation()

  return (
    <div>
      {showingNumberOfHits ? (
        <h2 className="heading-component u-text-xl u-leading-tiny u-font-weight-300">
          {t('Showing X of Y hits', { showingNumberOfHits, totalNumberOfHits })}
        </h2>
      ) : null}
    </div>
  )
}

export default TotalHits
